import { useQuery } from '@tanstack/react-query';

import InclusionsService from '~/services/InclusionsService';

import { inclusionsQueryKeys } from './inclusionsQueryKeys';

export interface InclusionCategory {
  id: string;
  category: string;
  name: string;
  icon: string;
}

export function useGetInclusionsCategories({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: inclusionsQueryKeys.categories(),
    queryFn: () => InclusionsService.getInclusionsCategories(),
    enabled,
    select: (response): Array<InclusionCategory> => response.result,
    staleTime: 5 * 60 * 1000,
  });
}
